import { useState, useEffect } from 'react';
import { formMetaData } from './productSearch.constant';
import isEmpty from 'lodash.isempty';

/**
 * Logic:- Products search requires certain filters to work with(for search api)
 * If any filters are empty, don't allow to edit.
 */
export default function useProductSearchDisable(props) {
    const { formID } = props.formInfo;
    const { fullData } = props;

    const [disableEdit, setdisableEdit] = useState(false);
    useEffect(() => {
        let patchedFormData = formMetaData[formID].moreInfo;
        let mandatoryKeys = [];
        let emptyFound = false;
        patchedFormData.searchFixedKeys.forEach((data) => {
            if (data.hasOwnProperty('formKey')) {
                mandatoryKeys.push(data.formKey);
            }
        });
        for (const key of mandatoryKeys) {
            if (isEmpty(fullData[key])) {
                emptyFound = true;
                break;
            }
        }
        setdisableEdit(emptyFound);
    }, [formID, fullData]);
    return [disableEdit];
}